import React from 'react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ActionButton as ActionButtonInterface } from 'types/button';
import { Meta } from 'types/meta';
import { NavigationButton } from './NavigationButton';
import { getTranslation } from 'localization/helpers';
import { Link } from 'react-router-dom';
import { Button } from 'styles/Button';
import { api } from 'services/api';
import arrowIcon from 'images/arrowIcon.svg';
import waiterIcon from 'images/bellIcon.svg';
import { formDataFromObject } from 'client/components/NavigationButtons/LinkButton';

interface ActionButtonProps {
  button: ActionButtonInterface;
  index: number;
  meta: Meta;
  payload: { [name: string]: string };
}

export const ActionButton: FC<ActionButtonProps> = ({
  button,
  index,
  meta,
  payload
}) => {
  const { i18n } = useTranslation();
  const formData = formDataFromObject(payload);
  let text = getTranslation(
    button.translations,
    'text',
    i18n.language,
    meta.default_locale
  );
  if (!text) text = '';

  return (
    <Button
      key={index}
      onClick={() => {
        api()
          .launchAction(formData)
          .then(data => {
            if (data.error) {
              // eslint-disable-next-line no-console
              console.error(data.error);
            }
          });
      }}
    >
      <Link to={'launch_action'}>
        <NavigationButton
          text={text}
          color={meta.color}
          icon={waiterIcon}
          arrow={arrowIcon}
        />
      </Link>
    </Button>
  );
};
